<div class="print-container">
    <h1 class="page-label">Print</h1>
</div>

<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">Item Code:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <input class="form-control" type="text" [(ngModel)]="itemCode" [readonly]="isPrinting" [disabled]="isPrinting" />
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">Quantity:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <input class="form-control" type="number" min="1" [(ngModel)]="quantity" [readonly]="isPrinting" [disabled]="isPrinting" />
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">Printer:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <select class="form-control" [(ngModel)]="selectedPrinter" [disabled]="isPrinting || isLoadingPrinters">
                            <option [ngValue]="null"> -- Choose Printer -- </option>
                            <option *ngFor="let printer of availablePrinters; index as i" [ngValue]="printer">{{printer}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">PO:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <input class="form-control" type="text" min="1" [(ngModel)]="po" [readonly]="isPrinting"
                            [disabled]="isPrinting" />
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">Family Name:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <input class="form-control" type="text" min="1" [(ngModel)]="familyName" [readonly]="isPrinting"
                            [disabled]="isPrinting" />
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">Warehouse:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <input class="form-control" type="text" min="1" [(ngModel)]="warehouse" [readonly]="isPrinting"
                            [disabled]="isPrinting" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="printClicked()" class="submit btn btn-primary col-sm-3" >Print</button>
    </div>
    <div *ngIf="printStatus != null" class="row">
        <h3 [class.api-result-error]="printStatus == 'error'" [class.api-result-success]="printStatus == 'success'" [class.api-result-pending]="printStatus == 'pending'">
            {{ printMessage }}
        </h3>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>